import { render, staticRenderFns } from "./NewAdministrators.vue?vue&type=template&id=708b89a3"
import script from "./NewAdministrators.vue?vue&type=script&lang=js"
export * from "./NewAdministrators.vue?vue&type=script&lang=js"
import style0 from "./NewAdministrators.vue?vue&type=style&index=0&id=708b89a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports